import React from "react";
import { Clock, FileText, Mail, MapPin, Phone } from "lucide-react";
import MarketingHeader from "../components/marketing/MarketingHeader";
import Footer from "../components/marketing/Footer";

const ContactPage = () => (
  <div className="min-h-screen bg-slate-50">
    <MarketingHeader />
    <section className="bg-slate-900 py-14 text-white sm:py-20">
      <div className="marketing-container max-w-4xl">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-3">Get In Touch</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight md:text-6xl">
          Have questions? We'd love to hear from you.
        </h1>
      </div>
    </section>
    <section className="section-padding">
      <div className="marketing-container grid gap-4 md:grid-cols-3 md:gap-6">
        {[
          { icon: Mail, title: "Email", value: "support@kampuscompanion.com", note: "For support, data requests, payments, and certificates." },
          { icon: Phone, title: "Phone", value: "+91 9217242305", note: "For registration, internship, and payment assistance." },
          { icon: MapPin, title: "Address", value: "Company Sarai, Rauza Road, Sasaram, Bihar - 821115", note: "Kampus Campanion, a Unit of Dmaskut Private Limited." },
        ].map((c) => (
          <div key={c.title} className="rounded-2xl border border-slate-200 bg-white p-5 mobile-premium-card sm:p-6">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50">
              <c.icon className="w-6 h-6 text-blue-600" />
            </div>
            <h3 className="font-heading font-semibold text-lg text-slate-900">{c.title}</h3>
            <p className="mt-1 break-words text-slate-600">{c.value}</p>
            <p className="text-sm text-slate-500 mt-3 leading-relaxed">{c.note}</p>
          </div>
        ))}
      </div>
      <div className="marketing-container mt-6 grid gap-4 md:mt-8 md:grid-cols-2 md:gap-6">
        <div className="rounded-2xl border border-slate-200 bg-white p-5 mobile-premium-card sm:p-6">
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50">
            <FileText className="w-6 h-6 text-blue-600" />
          </div>
          <h3 className="font-heading font-semibold text-lg text-slate-900">Privacy & Data Requests</h3>
          <p className="text-slate-600 mt-2 leading-relaxed">
            Contact us to request access, correction, or deletion of your account, student, payment, or certificate data. We may verify your identity before processing privacy requests.
          </p>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5 mobile-premium-card sm:p-6">
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50">
            <Clock className="w-6 h-6 text-blue-600" />
          </div>
          <h3 className="font-heading font-semibold text-lg text-slate-900">Support Flow</h3>
          <p className="text-slate-600 mt-2 leading-relaxed">
            Share your registered email, student ID, payment ID, or certificate ID when relevant so our team can locate your record and respond faster.
          </p>
        </div>
      </div>
    </section>
    <Footer />
  </div>
);

export default ContactPage;

